import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/expenses/recurring')({
  staticData: { crumb: 'recurringExpenses' },
  component: Outlet,
})
